import { Icon } from "simplydo/react/ui";

import type { CompanyPatent } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  InfoItem,
  KeyFactLink,
  KeyFactLinkSeeMore,
} from "../Styles";

type CompanyPatentsProps = {
  patents?: CompanyPatent[];
  total?: number;
  companyName: string;
};

const CompanyPatents = ({
  patents,
  total,
  companyName,
}: CompanyPatentsProps) => {
  if (patents?.length) {
    return (
      <InfoBoxWidget $sectioned>
        <InfoBoxWidgetTitleArea>
          <Icon name="archive" />
          <div>
            <h3>Patents</h3>
            <span>{total ?? patents.length} total patent(s)</span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          {patents.map((patent, index) => (
            <InfoItem
              key={patent.title ?? patent.googleUrl ?? index}
              href={patent.googleUrl}
            >
              <KeyFactLink
                title={patent.title ?? "Untitled patent"}
                fact={`Published: ${patent.date ?? "Unknown"}`}
              />
            </InfoItem>
          ))}
        </InfoContainer>
        {patents.length > 8 ?
          <KeyFactLinkSeeMore>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://datatool.patentsview.org/#search/assignee&asn=1|${companyName}`}
            >
              View more patents
            </a>
          </KeyFactLinkSeeMore>
        : null}
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyPatents;
